export const editMutations = <const>{
	SKLAD_PNEU_TEXTY_SELECT_MAPPER: 'SKLAD_PNEU_TEXTY_SELECT_MAPPER',
};
